module.exports = __webpack_public_path__ + "img/behavior.d7487e8a.png";